__turbopack_context__.v({
  "className": "jetbrains_mono_570956f9-module__WxSJZW__className",
  "variable": "jetbrains_mono_570956f9-module__WxSJZW__variable",
});
